const doc = [({"da":({"js":({"admin":({"subscription_periods":({"table":({"the_period_was_deleted":"Perioden blev slettet"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;